import { useState } from "react";
import { Button } from "@volca/ui/components/ui/button";
import { Stack } from "@volca/ui/components/ui/stack";
import { Textarea } from "@volca/ui/components/ui/textarea";
import { toast } from "@volca/ui/lib/toast";
import { reportError } from "@/profitability/utils";
import { useAddFindingNote } from "./query";

/** A note on the finding, kept in its activity. ⌘/Ctrl+Enter adds it. */
export const FindingNote = ({
  businessId,
  findingId,
}: {
  businessId: string;
  findingId: string;
}) => {
  const [body, setBody] = useState("");
  const add = useAddFindingNote(businessId);
  const submit = () => {
    if (!body.trim() || add.isPending) return;
    add.mutate(
      { findingId, body: body.trim() },
      {
        onSuccess: () => setBody(""),
        onError: (error) =>
          toast.error("The note could not be added", {
            description: reportError(error),
          }),
      },
    );
  };
  return (
    <Stack gap={2} align="stretch">
      <label htmlFor={`note-${findingId}`} className="sr-only">
        Leave a comment
      </label>
      <Textarea
        id={`note-${findingId}`}
        value={body}
        maxLength={2000}
        rows={1}
        placeholder="Leave a comment"
        className="min-h-9 resize-none text-base sm:text-sm pointer-coarse:min-h-11 pointer-coarse:text-base"
        onChange={(event) => setBody(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === "Enter" && (event.metaKey || event.ctrlKey)) {
            event.preventDefault();
            submit();
          }
        }}
      />
      {/* Only once there is something to add, so an empty box stays a line. */}
      {body.trim() && (
        <Button
          size="sm"
          className="self-end"
          disabled={add.isPending}
          loading={add.isPending}
          loadingLabel="Adding the note"
          onClick={submit}
        >
          Comment
        </Button>
      )}
    </Stack>
  );
};
